import { useEffect, useMemo } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../config/firebaseConfig";

// Refresh lock expiry by 15 min
async function refreshReviewLock(reportId: string) {
  if (!reportId) return;

  const lockRef = doc(db, "reports", reportId, "StatusInReview", "lock");
  const newExpiresAt = new Date(Date.now() + 15 * 60 * 1000);

  try {
    await updateDoc(lockRef, { expiresAt: newExpiresAt });
    console.log("🔄 Review lock refreshed");
  } catch (err) {
    console.error("Failed to refresh lock:", err);
  }
}

export function useAddReviewLock(reportId: string) {
  // Throttle so it runs once every 30 seconds
  const throttledRefresh = useMemo(() => {
    let lastCall = 0;
    return () => {
      const now = Date.now();
      if (now - lastCall > 30000) {
        refreshReviewLock(reportId);
        lastCall = now;
      }
    };
  }, [reportId]);

  useEffect(() => {
    if (!reportId) return;

    const handler = () => throttledRefresh();

    // Attach events that count as activity
    window.addEventListener("mousemove", handler);
    window.addEventListener("keydown", handler);
    window.addEventListener("scroll", handler);
    window.addEventListener("click", handler);

    return () => {
      window.removeEventListener("mousemove", handler);
      window.removeEventListener("keydown", handler);
      window.removeEventListener("scroll", handler);
      window.removeEventListener("click", handler);
    };
  }, [reportId, throttledRefresh]);
}
